import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Typography } from "@mui/material";
import { SalesInvoice001_DespatchDetail, SalesInvoice001_DespatchGetRow } from "../../../Server/ApiV2";
import { fAlertToast, fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
import { sTrnTyp } from "../SalesInvoiceAction";
import { SalesInvoiceRo } from "../../../Redux/roStore";

function DespatchDetailForm({ vocType = "", vocNo = "", vocTypeName = "" }) {
  const [formData, setFormData] = useState({
    dispatchDocumentNo: "",
    dispatchDocumentDate: "",
    dispatchThrough: "",
    destination: "",
    references: "",
    termsOfDelivery: "",
    contactName: "",
    contactPhone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleClear = (e) => {
    setFormData({
      dispatchDocumentNo: "",
      dispatchDocumentDate: "",
      dispatchThrough: "",
      destination: "",
      references: "",
      termsOfDelivery: "",
      contactName: "",
      contactPhone: "",
    });
  };
  const handleSubmit = async (e) => {
    console.log(formData);
    let obj = {
        "v_VocTyp": vocType,
        "v_VocNo": vocNo,
        "v_DocNo": formData.dispatchDocumentNo,
        "v_DocDt": formData.dispatchDocumentDate,
        "v_Party": formData.dispatchThrough,
        "v_Destination": formData.destination,
        "v_Reference": formData.references,
        "v_Terms": formData.termsOfDelivery,
        "v_TrnTyp": sTrnTyp,
        "v_ContactName": formData.contactName,
        "v_ContactPhone": formData.contactPhone
      }
    let resp = await SalesInvoice001_DespatchDetail(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Despatch details updated successfully ");
      // handleClear()
      GetRow()
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  };

  const GetRow=async()=>{
    const { HeadObject } = SalesInvoiceRo();
    let obj = { 
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo, 
      "v_TrnTyp": sTrnTyp
    };
     
    let resp = await SalesInvoice001_DespatchGetRow(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if(resp?.data?.ResultSet.length >0){
        let respData = resp?.data?.ResultSet[0];     
    
        setFormData((prevFormData)=>({
          ...prevFormData, 
          dispatchDocumentNo: respData.DocNo,
          dispatchDocumentDate: respData.DocDt,
          dispatchThrough: respData.Party,
          destination: respData.Destination,
          references: respData.Reference,
          termsOfDelivery: respData.Terms,
          contactName: respData.ContactName,
          contactPhone: respData.ContactPhone,
        }))
      }else{
        handleClear() 
      }
    
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  }
  
  
  useEffect(() => {
    GetRow()
  },[])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Document Type:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="documentType"
              value={vocType}
              onChange={()=>{}}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Document No:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="documentNo"
              value={vocNo}
              onChange={()=>{}}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Dispatch Document No:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="dispatchDocumentNo"
              value={formData.dispatchDocumentNo}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Dispatch Document Date:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="dispatchDocumentDate"
              value={formData.dispatchDocumentDate}
              onChange={handleChange}
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Dispatch Through:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="dispatchThrough"
              value={formData.dispatchThrough}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Destination:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="destination"
              value={formData.destination}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Reference(s):</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="references"
              value={formData.references}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Terms of Delivery:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="termsOfDelivery"
              value={formData.termsOfDelivery}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Contact Name:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="contactName"
              value={formData.contactName}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={4}>
            <Typography sx={{ color: "var(--primary)" }}>Contact Phone:</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              size="small"
              name="contactPhone"
              value={formData.contactPhone}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} container justifyContent="center" spacing={2}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClear}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default DespatchDetailForm;
